import { Typography } from '@mui/material';

type Props = {
  assetName?: string;
  widthOfElement?: number;
  heightOfElement?: number;
};

export const AssetNameLabel = ({ assetName, widthOfElement, heightOfElement }: Props) => (
  <Typography
    variant="body2"
    data-sm={assetName}
    sx={{
      mt: 0.5,
      textAlign: 'center',
      fontWeight: 600,
      maxWidth: '95%',
      whiteSpace: 'nowrap',
      fontSize: widthOfElement
        ? `${Math.max(widthOfElement!, heightOfElement!) * 0.035}px`
        : 'inherit',
    }}
  >
    {assetName ?? '-'}
  </Typography>
);
